import UIPhoneNumber from './UIPhoneNumber'
export default UIPhoneNumber
